import { GetVehiclesResponse } from '@retail-common/util-search-response-types'
import { getVehiclesUrlForSearchParams } from './utils/get-vehicles-url-for-search-params'
import { SearchVehiclesApiParams } from './types'

/**
 * Get vehicles from the search API.
 *
 * This returns both the response and requestUrl so it can be used during SSR to pre-populate a cache (e.g. SWR's `fallback`)
 *
 * @param searchServiceUrl base URL for the search API. Get this from Env.SearchServiceUrl
 * @param params search parameters to apply in the request (filters or other parameters)
 * @param channelId channelId to get vehicles from. Defaults to `cinch`
 */
export const fetchSearchVehicles = async (
  searchServiceUrl: string,
  params: Partial<SearchVehiclesApiParams>,
  channelId?: string,
): Promise<{ response: GetVehiclesResponse; requestUrl: string }> => {
  const requestUrl = getVehiclesUrlForSearchParams(
    searchServiceUrl,
    params,
    channelId,
  )
  const response = await fetch(requestUrl)
  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`)
  }
  const getVehiclesResponse = (await response.json()) as GetVehiclesResponse

  return { response: getVehiclesResponse, requestUrl }
}
